<template>
  <WpNaviLinks
    @hasActive="checkChanged"
    v-if="menus && menus.length"
    :menu="menus"
    :icons="icons"
  />
</template>

<script>
//import WpLink from "@/components/elements/WpLink";
import WpNaviLinks from "@/components/elements/WpNaviLinks";

export default {
  name: "wp-navi",
  props: ["location", "id", "icons"],
  components: {
    //WpLink,
    WpNaviLinks
  },
  mounted: function() {
    this.getMenu();
  },
  data() {
    return {
      menus: [],
      hasActiveChild: true
    };
  },
  methods: {
    checkChanged(emit) {},
    getMenu: function() {
      const vm = this;
      this.axios
        .get("wp-api-menus/v2/" + vm.menuEndpoint)
        .then(res => {
          if (vm.id && res.data.items) {
            vm.menus = res.data.items;
          } else {
            vm.menus = res.data;
          }
        })
        .catch(res => {
          console.log(
            `Something went wrong during loading menu: `,
            vm.menuEndpoint
          );
        });
    },
    getUrlName: function(url) {
      url = url.replace(/\/$/, "");
      const array = url.split("/");
      if (array.length === 3) {
        return "/";
      } else {
        return array[array.length - 1];
      }
    }
  },
  computed: {
    menuEndpoint() {
      if (this.location) {
        return "menu-locations/" + this.location;
      }
      if (this.id) {
        return "menus/" + this.id;
      }
      return "primary-menu";
    }
  }
};
</script>
